/* eslint-disable no-console */
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createApp } from 'vue';
import 'virtual:pwa-register/vue';
import Vue3Toastify, { type ToastContainerOptions } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

import App from '~/App.vue';
import vPermission from '~/directives/permission';
import router from '~/router';
import queryClient from '~/store/queryClient';
import '~/styles/main.scss';

import '@tabler/core/dist/js/tabler.min.js';

console.log(`${import.meta.env.VITE_APP_VERSION ?? 'development'}`);

createApp(App)
  .directive('permission', vPermission)
  .use(router)
  .use(VueQueryPlugin, { queryClient })
  .use(
    Vue3Toastify,
  {
    autoClose: 3000,
    position: 'top-right',
  } as ToastContainerOptions,
  )
  .mount('#app');
